import {SidebarPageLayout} from '@github-ui/layout-primitives/SidebarPageLayout'
import {Link} from '@github-ui/react-router'
import {useRepoIssuesSidebarLayoutEnabled} from '@github-ui/repo-issues-page-layout/useSidebarLayoutEnabled'
import {Button, Heading} from '@primer/react'
import {useFragment} from 'react-relay'
import {graphql} from 'relay-runtime'

import type {MilestonesActions$key} from './__generated__/MilestonesActions.graphql'
import {LABELS} from './constants/labels'
import styles from './RepositoryMilestone.module.css'

type MilestonesActionsProps = {
  repositoryRef: MilestonesActions$key
}

export function MilestonesActions({repositoryRef}: MilestonesActionsProps) {
  const {viewerCanPush, nameWithOwner} = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment MilestonesActions on Repository {
        viewerCanPush
        nameWithOwner
      }
    `,
    repositoryRef,
  )

  const newMilestoneUrl = `/${nameWithOwner}/milestones/new`

  if (useRepoIssuesSidebarLayoutEnabled()) {
    return null
  }

  return (
    <div className={styles.buttonGrp}>
      <div className={styles.titleGroup}>
        <SidebarPageLayout.SidebarTrigger />
        <Heading as="h1" className={styles.heading}>
          Milestones
        </Heading>
      </div>

      {viewerCanPush ? (
        <div className={styles.actionsGrp}>
          <Button as={Link} to={newMilestoneUrl} variant="primary" data-testid="new-milestone-button">
            {LABELS.newMilestone}
          </Button>
        </div>
      ) : null}
    </div>
  )
}
